import React, { useEffect, useState } from 'react'
//panel del filtro
import HeaderTitle from './Components/HeaderTitle'
import Highcharts from 'highcharts'
import HCSoldGauge from 'highcharts/modules/solid-gauge';
import { setearMiles } from "util/funciones"
import { determinateDate, determinateOperation } from '../ChartHelpers/Chart.helper';
import { formatearFecha, formatosFecha } from 'util/formatDate';
import FiltrosFecha from './Components/FiltrosFecha';
import { getChartsData } from '../ChartHelpers/Charts.services';
import { IDatasetChart } from '../ChartHelpers/Charts.interface';
import { FiltrosOperation } from './Components';
window.Highcharts = Highcharts;
HCSoldGauge(Highcharts);
const ChartDiasMasVentas = ({ updateData, identificadorEstacion }: any): React.ReactElement => {
    const [selectionDate, setSelectionDate] = useState(1)
    const [selectionOperation, setSelectionOperation] = useState(3)

    useEffect(() => {
        getData()
    }, [updateData, selectionDate, selectionOperation,identificadorEstacion])

    const getData = async (): Promise<void> => {
        const { fechaInicial, fechaFinal } = determinateDate(selectionDate)
        const { operacion, estadoMovimiento } = determinateOperation(selectionOperation)
        const body = {
            fecha_inicial: fechaInicial,
            fecha_final: fechaFinal,
            identificadorEstacion: identificadorEstacion,
            tipoMovimiento: operacion,
            tipoEstadoMovimiento: estadoMovimiento
        };
        const data = await getChartsData('VENTAS_TOP_POR_DIA', body)
        construirDatos(data)
    }

    const construirDatos = (datos: any[]) => {
        const data: IDatasetChart = {
            categories: [],
            series: []
        }
        try {
            if (datos != null) {
                datos.forEach((semana) => {
                    data.categories.push(formatearFecha(semana.fecha, formatosFecha.fecha))
                    data.series.push(parseFloat(semana.sum))
                })
            }
        } catch (error) { }
        construirGrafico(data.categories, data.series)
    }



    const construirGrafico = (categories: string[], series: any[]): void => {
        Highcharts.chart("ventas-combustible-top-dias", {
            chart: {
                type: "bar",
            },
            title: {
                text: "",
            },
            tooltip: {
                formatter(this: Highcharts.TooltipFormatterContextObject) {
                    return ' $ ' + setearMiles(this.point.y);
                }
            },
            xAxis: {
                categories: categories,
            },
            yAxis: {
                min: 0,
                title: {
                    text: "TOTAL VENTAS",
                },
            },
            legend: {
                reversed: true,
            },
            plotOptions: {
                series: {
                    stacking: "normal",
                },
            },
            series: [{
                name: "ventas",
                data: series
            }],
        } as any);
    }


    return (
        <>
            <HeaderTitle title={'DIAS CON MAS VENTAS'} />
            <FiltrosFecha noToday={true} onChange={(selection: number) => setSelectionDate(selection)} prevActive={selectionDate} />
            <FiltrosOperation onChange={(selection: number) => setSelectionOperation(selection)} prevActive={selectionOperation} />
            <div
                id="ventas-combustible-top-dias"
                className="col-md-11 mx-auto"
            /*style={
                isShow
                    ? { marginTop: "15px", display: "block" }
                    : { display: "none" }
            }*/
            ></div>
        </>
    )
}
export default ChartDiasMasVentas
